module.exports = __webpack_public_path__ + "static/media/iconSchedule.5a7c7619.svg";